export const RATE_LIMIT_CONFIG = {
  // =============================================================================
  // CONTENT INTERACTION RATE LIMITS
  // =============================================================================
  
  // Comment rate limits (implemented in AddComment2.jsx, ViewGame)
  COMMENT: {
    free: { limit: 4, windowMs: 2 * 60 * 1000 },      // 4 comments per 2 minutes
    premium: { limit: 10, windowMs: 2 * 60 * 1000 }   // 10 comments per 2 minutes
  },
  
  // Game submission rate limits (implemented in AddGame components)
  POST_GAME: {
    free: { limit: 3, windowMs: 120 * 1000 },          // 3 games per 2 minutes
    premium: { limit: 5, windowMs: 120 * 1000 }        // 2 games per 2 minutes
  },
  
  // User follow/unfollow rate limits (implemented in useFollowSystem hook)
  FOLLOW: {
    free: { limit: 10, windowMs: 5 * 60 * 1000 },     // 10 follows per 5 minutes
    premium: { limit: 10, windowMs: 5 * 60 * 1000 }   // Same for all users
  },

  // =============================================================================
  // AUTHENTICATION & SECURITY RATE LIMITS
  // =============================================================================
  
  // Login attempt rate limits (prevents brute force attacks)
  SIGNIN_ATTEMPT: {
    free: { limit: 5, windowMs: 5 * 60 * 1000 },      // 5 attempts per 15 minutes
    premium: { limit: 5, windowMs: 5 * 60 * 1000 }    // Same for all users
  },

  // Account creation rate limits (prevents spam accounts)
  SIGNUP_ATTEMPT: {
    free: { limit: 5, windowMs: 10 * 60 * 1000 },     
    premium: { limit: 5, windowMs: 10 * 60 * 1000 }   
  },

  // Password reset rate limits (prevents email spam)
  PASSWORD_RESET: {
    free: { limit: 3, windowMs: 60 * 60 * 1000 },      // 3 resets per hour
    premium: { limit: 3, windowMs: 60 * 60 * 1000 }    // Same for all users
  }
};

/**
 * Get rate limit configuration for a specific action and user tier
 * @param {string} action - The action type (e.g., 'COMMENT', 'POST_GAME')
 * @param {string} userTier - User tier ('free' or 'premium')
 * @returns {object} Rate limit config with limit and windowMs properties
 */
export const getRateLimit = (action, userTier = 'free') => {
  return RATE_LIMIT_CONFIG[action]?.[userTier] || RATE_LIMIT_CONFIG[action]?.free;
};

/**
 * Build rate limit key for per-game actions
 * @param {string} userId - User ID
 * @param {string} gameId - Game ID
 * @param {string} action - Action type
 * @returns {string} Rate limit key
 */
export const buildRateKey = (userId, gameId, action) => {
  return `${userId}:${gameId}:${action}`;
};

/**
 * Build rate limit key for global actions (not tied to specific game)
 * @param {string} userId - User ID
 * @param {string} action - Action type
 * @returns {string} Rate limit key
 */
export const buildGlobalRateKey = (userId, action) => {
  return `${userId}:global:${action}`;
}; 